























































import { Component, Prop } from 'vue-property-decorator'
import { HsComponent } from '@hds/help-common/src/components/hs-components'

@Component({
  middleware: async (ctx) => {
    // todo: middleware
  },
  validate: async (ctx) => {
    // todo: validate
    return true
  },
  asyncData: async (ctx) => {
    // todo: asyncData
  },
})
/**
 * @vuese
 * @group component group
 * component description
 */
export default class extends HsComponent {
  // #region variables
  @Prop({ default: false }) dialogTitle!: string | boolean
  @Prop({ default: '다이알로그 내용' }) message!: string
  @Prop({ default: 'center' }) readonly contentAlign!: string
  @Prop({ default: '확인' }) readonly agreeLabel!: string | boolean
  @Prop({ default: '취소' }) readonly cancelLabel!: string | boolean
  @Prop({ default: 500 }) readonly width!: number | string
  @Prop({ default: 200 }) readonly height!: number | string
  @Prop({ default: 202 }) readonly zIndex!: number

  confirmDialog = false
  resolve = null
  reject = null
  dialogMessage: string | boolean = this.message
  confirmTitle: string | boolean = this.dialogTitle
  dialogOptions = {
    agreeLabel: this.agreeLabel,
    cancelLabel: this.cancelLabel,
    contentAlign: this.contentAlign,
    width: this.width,
    height: this.height,
    zIndex: this.zIndex,
  }

  // #endregion

  // #region hooks
  // #endregion

  // #region methods
  open(message: string, dialogTitle?: string, dialogOptions?: object) {
    this.confirmDialog = true
    this.confirmTitle = dialogTitle === undefined ? false : dialogTitle
    this.dialogMessage = message
    this.dialogOptions = Object.assign(this.dialogOptions, dialogOptions)
    return new Promise((resolve, reject) => {
      this.resolve = resolve
      this.reject = reject
    })
  }

  agree() {
    this.resolve(true)
    this.confirmDialog = false
  }

  cancel() {
    this.resolve(false)
    this.confirmDialog = false
  }
  // #endregion

  // #region watches
  // #endregion
}
